<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle33')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle33') }}</h1>
    <p>{{ $t('artText33-1') }}</p>
    <img
      :src="`${staticUrl}/images/blog/This_Home_Design_App_is_Key_To_Your_Studio_Apartment_Inspiration.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText33-2') }}</h2>
    <p>{{ $t('artText33-3') }}</p>
    <h2>{{ $t('artText33-4') }}</h2>
    <p>{{ $t('artText33-5') }}</p>
    <h2>{{ $t('artText33-6') }}</h2>
    <p>{{ $t('artText33-7') }}</p>
    <h2>{{ $t('artText33-8') }}</h2>
    <p>{{ $t('artText33-9') }}</p>
    <h2>{{ $t('artText33-10') }}</h2>
    <p>{{ $t('artText33-11') }}</p>
    <h2>{{ $t('artText33-12') }}</h2>
    <p>{{ $t('artText33-13') }}</p>
    <h2>{{ $t('artText33-14') }}</h2>
    <p>{{ $t('artText33-15') }}</p>
    <h2>{{ $t('artText33-16') }}</h2>
    <p>{{ $t('artText33-17') }}</p>
    <img
      :src="`${staticUrl}/images/blog/This_Home_Design_App_is_Key_To_Your_Studio_Apartment_Inspiration_1.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText33-18') }}</h2>
    <p>{{ $t('artText33-19') }}</p>
    <h2>{{ $t('artText33-20') }}</h2>
    <p>{{ $t('artText33-21') }}</p>
    <h2>{{ $t('artText33-22') }}</h2>
    <p>{{ $t('artText33-23') }}</p>
    <h2>{{ $t('artText33-24') }}</h2>
    <p>{{ $t('artText33-25') }}</p>
    <h2>{{ $t('artText33-26') }}</h2>
    <p>{{ $t('artText33-27') }}</p>
    <h2>{{ $t('artText33-28') }}</h2>
    <p>{{ $t('artText33-29') }}</p>
    <h2>{{ $t('artText33-30') }}</h2>
    <p>{{ $t('artText33-31') }}</p>
    <p>{{ $t('artText33-32') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle33')}`,
  ogTitle: `${t('artSeoTitle33')}`,
  description: `${t('artSeoDesc33')}`,
  ogDescription: `${t('artSeoDesc33')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
